<template>
  <div>
    <div class="modal-body">
      <app-input type="text" v-model="formBuilderModel.name" label="Name"/>

      <div v-if="role === 'admin'" class="fbf-admin-only">
        <app-checkbox label="Admin Only" size="lg" v-model="formBuilderModel.admin_only" />
      </div>

      <div class="row">
        <div class="col-md-12">
          <div id="fb-editor"></div>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <div class="fbf-actions">
        <app-button
          type="button"
          theme="secondary"
          variant="white"
          icon="fa-xmark"
          @click="$emit('cancel')"
        >Cancel</app-button>

        <app-button
          type="button"
          theme="success"
          icon="fa-check"
          :show-indicator="showIndicator"
          @click="updateFormBuilderData()"
        >Save</app-button>
      </div>
    </div>
  </div>
</template>

<script>
import { hideFormBuilderOptionValues } from "../../helpers/formBuilder";
import '../../libraries/form-builder.min.js';
import '../../libraries/form-render.min.js';
export default {
  props: ['url', 'duplicateId', 'id', 'type', 'role'],
  data() {
    return {
      isFetching: false,
      showIndicator: false,
      formBuilderModel: {
        name: '',
        form_fields: [],
        admin_only: false,
      },
      formBuilder: null,
    }
  },
  mounted() {
    if (this.type === 'disclosure') {
      if (this.id) {
        $('.page-title:first').text('Edit Disclosure Form');
      } else {
        $('.page-title:first').text('Create Disclosure Form');
      }
    } else if (this.type === 'additional-form') {
      if (this.id) {
        $('.page-title:first').text('Edit Additional Form');
      } else {
        $('.page-title:first').text('Create Additional Form');
      }
    }

    this.getFormBuilderData();
  },
  methods: {
    initFormBuilder() {
      var self = this;

      var options = {
        disableFields: [
          'autocomplete',
          'button',
          'file',
          'hidden'
        ],
        disabledActionButtons: [
          'data',
          'clear',
          'edit',
          'save'
        ],
        disabledFieldButtons: {
          'IneligibleCompanyTable': ['edit']
        },
        disabledAttrs: [
          'access',
          'className',
          'step',
          'placeholder',
          'toggle',
          'other',
          'is_default'
        ],
        typeUserEvents: {
          text: {}
        },
        formData: JSON.stringify(this.formBuilderModel.form_fields),
        editOnAdd: false,
        onSave: function () {
          self.updateFormBuilderData();
        },
        onOpenFieldEdit: function (fieldId) {
          setTimeout(hideFormBuilderOptionValues, 100);
        },
      };

      let fields = [{
        label: 'Ineligible Company Table',
        attrs: {
          type: 'IneligibleCompanyTable'
        },
        icon: '🌟'
      }];
      let financialOptions = '<option value="">None</option>' +
          '<option value="advisor">Advisor</option>' +
          '<option value="employee">Employee</option>' +
          '<option value="researcher">Researcher</option>' +
          '<option value="consultant">Consultant</option>' +
          '<option value="speaker">Speaker</option>' +
          '<option value="independent_contractor">Independent Contractor</option>' +
          '<option value="royalty_or_patent_beneficiary">Royalty or Patent Beneficiary</option>' +
          '<option value="executive_role">Executive Role</option>' +
          '<option value="ownership_interest">Ownership Interest</option>';
      let templates = {
        IneligibleCompanyTable(fieldData) {
          return {
            field: '<table>' +
                '<tr>' +
                '<td colspan="3"><strong>To be Completed by Planner, Faculty, or Others Who May Control Educational Content</strong><br/>' +
                'Please disclose <strong>all financial relationships</strong> that you have had in the past 24 months with ineligible companies ' +
                '(see definition above). For each financial relationship, enter the name of the ineligible company and the nature of the ' +
                'financial relationship(s). There is no minimum financial threshold; we ask that you disclose all financial relationships, ' +
                'regardless of the amount, with ineligible companies. You should disclose all financial relationships regardless of the ' +
                'potential relevance of each relationship to the education.</td></tr><tr>' +
                '<tr><td colspan="3"><div class="form-check"><input type="checkbox" name="is_any_financial_relationship" class="form-check-input" id="any-financial-relationship" /> ' +
                '<label class="form-check-label" for="any-financial-relationship"> In the past 24 months, I have not had <strong>any</strong> financial ' +
                'relationships with any ineligible companies. (If you check this box, do NOT fill out the table below)</label></div></td></tr>' +
                '<td><strong>Enter the Name of Ineligible Company</strong><br/> An <strong>ineligible company</strong> is any entity whose ' +
                'primary business is producing, marketing, selling, re-selling, or distributing healthcare products used by or on patients.<br/>' +
                'For specific examples of ineligible companies visit <strong>accme.org.standards</strong>.</td>' +
                '<td><strong>Enter the Nature of Financial Relationship</strong><br/> Examples of financial relationships include employee,' +
                'researcher, consultant, advisor, speaker, independent contractor (including contracted research), royalties or patent ' +
                'beneficiary, executive role, and ownership interest. Individual stocks and stock options should be disclosed; diversified ' +
                ' mutual funds do not need to be disclosed. Research funding from ineligible companies should be disclosed by the principal ' +
                'or named investigator even if that individual\'s institution receives the research grant and manages the funds.</td>' +
                '<td><strong>Has the Relationship Ended?</strong><br/> If the financial relationship existed during the last 24 months, ' +
                'but has now ended, please check the box in this column. This will help the education staff determine if any mitigation steps ' +
                'need to be taken</td></tr>' +
                '<tr>' +
                '<td><input type="text" name="ineligible_company_1" class="form-control" /></td>' +
                '<td><select name="financial_relationship_1" class="form-control">' + financialOptions + '</select></td>' +
                '<td><div class="form-check text-center"><input type="checkbox" name="is_relationship_ended_1" class="form-check-input" /></div></td>' +
                '</tr>' +
                '<tr>' +
                '<td><input type="text" name="ineligible_company_2" class="form-control" /></td>' +
                '<td><select name="financial_relationship_2" class="form-control">' + financialOptions + '</select></td>' +
                '<td><div class="form-check text-center"><input type="checkbox" name="is_relationship_ended_2" class="form-check-input" /></div></td>' +
                '</tr>' +
                '<tr>' +
                '<td><input type="text" name="ineligible_company_3" class="form-control" /></td>' +
                '<td><select name="financial_relationship_3" class="form-control">' + financialOptions + '</select></td>' +
                '<td><div class="form-check text-center"><input type="checkbox" name="is_relationship_ended_3" class="form-check-input" /></div></td>' +
                '</tr>' +
                '<tr>' +
                '<td><input type="text" name="ineligible_company_4" class="form-control" /></td>' +
                '<td><select name="financial_relationship_4" class="form-control">' + financialOptions + '</select></td>' +
                '<td><div class="form-check text-center"><input type="checkbox" name="is_relationship_ended_4" class="form-check-input" /></div></td>' +
                '</tr>' +
                '<tr>' +
                '<td><input type="text" name="ineligible_company_5" class="form-control" /></td>' +
                '<td><select name="financial_relationship_5" class="form-control">' + financialOptions + '</select></td>' +
                '<td><div class="form-check text-center"><input type="checkbox" name="is_relationship_ended_5" class="form-check-input" /></div></td>' +
                '</tr>' +
                '<tr>' +
                '<td><input type="text" name="ineligible_company_6" class="form-control" /></td>' +
                '<td><select name="financial_relationship_6" class="form-control">' + financialOptions + '</select></td>' +
                '<td><div class="form-check text-center"><input type="checkbox" name="is_relationship_ended_6" class="form-check-input" /></div></td>' +
                '</tr>' +
                '<tr>' +
                '<td><input type="text" name="ineligible_company_7" class="form-control" /></td>' +
                '<td><select name="financial_relationship_7" class="form-control">' + financialOptions + '</select></td>' +
                '<td><div class="form-check text-center"><input type="checkbox" name="is_relationship_ended_7" class="form-check-input" /></div></td>' +
                '</tr>' +
                '<tr>' +
                '<td><input type="text" name="ineligible_company_8" class="form-control" /></td>' +
                '<td><select name="financial_relationship_8" class="form-control">' + financialOptions + '</select></td>' +
                '<td><div class="form-check text-center"><input type="checkbox" name="is_relationship_ended_8" class="form-check-input" /></div></td>' +
                '</tr>' +
                '<tr>' +
                '<td><input type="text" name="ineligible_company_9" class="form-control" /></td>' +
                '<td><select name="financial_relationship_9" class="form-control">' + financialOptions + '</select></td>' +
                '<td><div class="form-check text-center"><input type="checkbox" name="is_relationship_ended_9" class="form-check-input" /></div></td>' +
                '</tr>' +
                '</table',
            onRender: function () {}
          };
        }
      };

      options.fields = fields;
      options.templates = templates;
      options.disableHTMLLabels = true;

      this.formBuilder = $(document.getElementById('fb-editor')).formBuilder(options);
    },

    /**
     * Set form builder data
     */
    getFormBuilderData() {
      this.initFormBuilder();

      let url = this.url;

      if (this.id) {
        url += `/${this.id}`;
      }
      else if (this.duplicateId) {
        url += `/${this.duplicateId}`;
      }
      else {
        if (this.type === 'forms') {
          url += `/create`;
        } else {
          url += `/create/${this.type}`;
        }
      }

      this.isFetching = true;
      axios.get(url).then((resp) => {
        if (this.type === 'forms') {
          this.formBuilderModel = {
            ...resp.data,
            name: resp.data.name,
            form_fields: resp.data.form_fields ? resp.data.form_fields : [],
            admin_only: resp.data.admin_only || resp.admin_only || 0
          };
        } else {
          this.formBuilderModel = {
            ...resp.data,
            name: resp.data.name,
            form_fields: resp.data.form_fields ? resp.data.form_fields : []
          };
        }

        setTimeout(() => {
          if (this.formBuilder) {
            this.formBuilder.actions.setData(JSON.stringify(this.formBuilderModel.form_fields));

            setTimeout(() => {
              var blocks = $(".field-label");

              blocks.each(function () {
                $(this).text().trim();
              });
            }, 100);
          }
        }, 500);
      })
      .catch(() => {})
      .finally(() => {
        this.isFetching = false;
      });
    },

    updateFormBuilderData() {
      var url = this.url;

      var data = {
        name: this.formBuilderModel.name,
        form_fields: JSON.parse(this.formBuilder.formData),
        type: this.type
      };

      if (this.type === 'forms') {
        data.admin_only = this.formBuilderModel.admin_only;
      }

      this.showIndicator = true;

      if (this.id) {
        axios.put(`${url}/${this.id}`, data).then((res) => {

          this.$emit('edit-success', res.data)
          notifier.success('Form has been successfully updated!');
        }).catch((data) => {
              notifier.error(data.flash);

            }).finally(() => {
          setTimeout(() => {
            this.showIndicator = false;
          }, 1000);
        });
      } else {
        axios.post(url, data).then((res) => {
          this.$emit('create-success', res.data)
          notifier.success('Form has been successfully saved!');
        }).catch((data) => {
              notifier.error(data.flash);

        }).finally(() => {
          setTimeout(() => {
            this.showIndicator = false;
          }, 1000);
        });
      }
    }

  }
}
</script>

<style>
.form-wrap.form-builder .stage-wrap,
.form-wrap.form-builder .stage-wrap.empty {
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 1rem 2rem;
}

.form-wrap.form-builder .btn-group > .btn {
  color: #ffffff;
}

.cb-wrap {
  inset: 55px auto auto 916px !important;
}

/* Breathing room between the Name input and the Admin Only checkbox. */
.fbf-admin-only {
  margin-top: 14px;
  margin-bottom: 18px;
}

/* Footer actions: Cancel (left) ↔ Save (right), like the other modals. */
.fbf-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
</style>